<template>
  <div class="country-experiences-panel">
    <h6 class="mb-1">Travel experience</h6>
    <p class="mb-3">Has the traveller been on business travel to these locations previously?</p>
    <table class="table table-sm table-borderless sc-table-fixed">
      <tr repeat.for="item of items" class="${item.revisit == null ? 'is-invalid' : ''}">
        <td><i class="${getItemIcon(item)} fa-fw"></i> ${item.country.name}</td>
        <td width="45px" style="text-align: right">
          <label class="country-experiences-panel__radio">
            <input type="radio" name="${radioName}-${item.country.id}" model.bind="true" checked.bind="item.revisit" disabled.bind="disabled"> yes
          </label>
        </td>
        <td width="45px" style="text-align: right">
          <label class="country-experiences-panel__radio">
            <input type="radio" name="${radioName}-${item.country.id}" model.bind="false" checked.bind="item.revisit" disabled.bind="disabled"> no
          </label>
        </td>
      </tr>
    </table>
  </div>
</template>
